import {FunctionComponent, useMemo, useState} from 'react';
import {isEmpty} from 'lodash';
import ComboboxContent, {ComboboxContentProps, ComboboxValue} from '@/components/form/combobox/combobox-content';

type ComboboxProps = Omit<ComboboxContentProps, 'setQuery' | 'isLoading' | 'showEmptyResults'>;

const Combobox: FunctionComponent<ComboboxProps> = ({
  ['data-testid']: dataTestId,
  selectedValue,
  values,
  placeholder,
  multiple = false,
  onChange,
  onFocus,
  onBlur,
  ...props
}) => {
  const [query, setQuery] = useState('');

  const filteredValues = useMemo(() => getFilteredComboboxValues(values, query), [values, query]);

  return (
    <ComboboxContent
      {...props}
      data-testid={dataTestId}
      placeholder={placeholder}
      multiple={multiple}
      selectedValue={selectedValue}
      showEmptyResults={isEmpty(filteredValues)}
      values={filteredValues}
      isLoading={false}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      setQuery={setQuery}
    />
  );
};

const getFilteredComboboxValues = (values: ComboboxValue[], query: string): ComboboxValue[] => {
  if (query === '') {
    return values;
  }
  return values.filter(value => value.label.toLowerCase().includes(query.toLowerCase()));
};

export {type ComboboxProps, Combobox as default};
